import AbstractCustomerValueModel from '../abstract_customer_value_model';
import BenefitsChartValue from '../../charts/benefits_chart_value';
import BenefitsWaterfallChart from '../../charts/symplr/benefits_waterfall_chart';

class SymplrGrc extends AbstractCustomerValueModel {
  custom_chart_classes() {
    return { BenefitsChartValue, BenefitsWaterfallChart };
  }

  percent_reduction_in_time_managing_docs_contract() {
    return this.input.percent_reduction_in_time_managing_docs_contract / 100;
  }

  percent_reduction_in_time_managing_docs_compliance() {
    return this.input.percent_reduction_in_time_managing_docs_compliance / 100;
  }

  percent_reduction_in_time_reporting_contract() {
    return this.input.percent_reduction_in_time_reporting_contract / 100;
  }

  percent_reduction_in_time_reporting_compliance() {
    return this.input.percent_reduction_in_time_reporting_compliance / 100;
  }

  percent_reduction_in_time_tracking_issues() {
    return this.input.percent_reduction_in_time_tracking_issues / 100;
  }

  percent_reduction_in_prob_penalty() {
    return this.input.percent_reduction_in_prob_penalty / 100;
  }

  reduction_in_reputational_damaging_incidents() {
    return this.input.reduction_in_reputational_damaging_incidents;
  }

  reduction_in_risk_assessments() {
    return this.input.reduction_in_risk_assessments;
  }

  adoption_rate_year_1() {
    return this.input.adoption_rate_year_1 / 100;
  }

  adoption_rate_year_2() {
    return this.input.adoption_rate_year_2 / 100;
  }

  adoption_rate_year_3() {
    return this.input.adoption_rate_year_3 / 100;
  }

  adoption_rate_year_4() {
    return this.input.adoption_rate_year_4 / 100;
  }

  adoption_rate_year_5() {
    return this.input.adoption_rate_year_5 / 100;
  }

  adoption_rate(year) {
    switch (year) {
      case 1: return this.adoption_rate_year_1();
      case 2: return this.adoption_rate_year_2();
      case 3: return this.adoption_rate_year_3();
      case 4: return this.adoption_rate_year_4();
      case 5: return this.adoption_rate_year_5();
      default: return 1.0;
    }
  }

  annual_contract_mgr_salary() { //G29
    return this.input.annual_contract_mgr_salary;
  }

  annual_compliance_mgr_salary() { //G30
    return this.input.annual_compliance_mgr_salary;
  }

  annual_price_increase(year) {
    return (1 + (this.input.annual_increase / 100)) ** (year - 1);
  }

  assumed_impact_of_reputational_dmg() { //G23
    return this.input.assumed_impact_of_reputational_dmg / 100;
  }

  avg_cost_of_external_assessment() { //G25
    return this.input.avg_cost_of_external_assessment;
  }

  avg_operating_margin() { //G24
    return this.input.avg_operating_margin / 100;
  }

  burden_rate() {
    return this.input.burden_rate;
  }

  compliance_license_fee() {
    return this.input.compliance_license_fee;
  }

  compliance_implementation_fee() {
    return this.input.compliance_implementation_fee;
  }

  contract_implementation_fee() {
    return this.input.contract_implementation_fee;
  }

  contract_license_fee() {
    return this.input.contract_license_fee;
  }

  fte_managing_compliance_docs() {
    return this.input.fte_managing_compliance_docs;
  }

  fte_managing_contract_docs() { // G14
    return this.input.fte_managing_contract_docs;
  }

  fully_burdened_salary(salary) {
    return salary * this.burden_rate();
  }

  hours_per_year() {
    return 1880;
  }

  net_patient_revenue() { //G8
    return this.input.net_patient_revenue;
  }

  no_of_contracts() { //Configurator - G20
    return this.input.no_of_contracts;
  }

  probability_of_penalty() { //G22
    return this.input.probability_of_penalty / 100;
  }

  product_compliance() {
    return this.input.product_compliance;
  }

  product_contract() {
    return this.input.product_contract;
  }

  size_of_potential_penalty() { //G21
    return this.input.size_of_potential_penalty;
  }

  time_managing_compliance_docs() {
    return this.input.time_managing_compliance_docs;
  }

  time_managing_contract_docs() { //G15
    return this.input.time_managing_contract_docs;
  }

  time_on_compliance_reporting() { //G17
    return this.input.time_on_compliance_reporting;
  }

  time_on_contract_reporting() { //G16
    return this.input.time_on_contract_reporting;
  }

  time_tracking_issues() { //G18
    return this.input.time_tracking_issues;
  }

  weeks_per_year() {
    return 52;
  }

  // Benefit 1
  reduce_time_managing_docs() {
    return this.reduce_time_managing_docs_contract()
      + this.reduce_time_managing_docs_compliance();
  }

  reduce_time_managing_docs_contract() {
    if (this.product_contract() === 0) { return 0; }

    return this.fte_managing_contract_docs()
      * (this.time_managing_contract_docs() * this.weeks_per_year())
    * (this.fully_burdened_salary(this.annual_contract_mgr_salary()) / this.hours_per_year())
      * this.percent_reduction_in_time_managing_docs_contract();
  }

  reduce_time_managing_docs_compliance() {
    if (this.product_compliance() === 0) { return 0; }

    return this.fte_managing_compliance_docs()
      * (this.time_managing_compliance_docs() * this.weeks_per_year())
    * (this.fully_burdened_salary(this.annual_compliance_mgr_salary()) / this.hours_per_year())
      * this.percent_reduction_in_time_managing_docs_compliance();
  }

  // Benefit 2
  reduce_time_reporting() {
    return this.reduce_time_reporting_contract()
      + this.reduce_time_reporting_compliance();
  }

  reduce_time_reporting_contract() {
    if (this.product_contract() === 0) { return 0; }

    return this.fte_managing_contract_docs()
      * (this.time_on_contract_reporting() * 12)
    * (this.fully_burdened_salary(this.annual_contract_mgr_salary()) / this.hours_per_year())
      * this.percent_reduction_in_time_reporting_contract();
  }

  reduce_time_reporting_compliance() {
    if (this.product_compliance() === 0) { return 0; }

    return this.fte_managing_compliance_docs()
      * (this.time_on_compliance_reporting() * 12)
    * (this.fully_burdened_salary(this.annual_compliance_mgr_salary()) / this.hours_per_year())
      * this.percent_reduction_in_time_reporting_compliance();
  }

  // Benefit 3
  reduce_time_tracking_issues() {
    if (this.product_compliance() === 0) { return 0; }

    return this.fte_managing_compliance_docs() * (this.time_tracking_issues() * this.weeks_per_year())
      * (this.fully_burdened_salary(this.annual_compliance_mgr_salary()) / this.hours_per_year())
    * this.percent_reduction_in_time_tracking_issues();
  }

  // Benefit 4
  avoid_penalties() {
    return this.size_of_potential_penalty()
      * this.probability_of_penalty()
      * this.percent_reduction_in_prob_penalty();
  }

  // Benefit 5
  avoid_reputational_damage() {
    if (this.product_compliance() === 0) { return 0; }

    return (this.net_patient_revenue() * this.assumed_impact_of_reputational_dmg())
      * this.avg_operating_margin()
    * this.reduction_in_reputational_damaging_incidents();
  }

  // Benefit 6
  reduce_cost_of_external_assessments() {
    if (this.product_compliance() === 0) { return 0; }

    return this.avg_cost_of_external_assessment() * this.reduction_in_risk_assessments();
  }

  all_benefits() {
    return [
      'reduce_time_managing_docs',
      'reduce_time_reporting',
      'reduce_time_tracking_issues',
      'avoid_penalties',
      'avoid_reputational_damage',
      'reduce_cost_of_external_assessments'
    ];
  }

  value_drivers() {
    return [
      'streamline_healthcare_operations',
      'mitigate_risk'
    ];
  }

  streamline_healthcare_operations() {
    return this.reduce_time_managing_docs()
      + this.reduce_time_reporting()
      + this.reduce_time_tracking_issues();
  }

  mitigate_risk() {
    return this.avoid_penalties()
      + this.avoid_reputational_damage()
      + this.reduce_cost_of_external_assessments();
  }

  total_annual_investment(year = 1) {
    let cost = 0;

    if (this.product_compliance() === 1) {
      cost += this.compliance_license_fee();
      if (year === 1) {
        cost += this.compliance_implementation_fee();
      }
    }

    if (this.product_contract() === 1) {
      cost += this.contract_license_fee();
      if (year === 1) {
        cost += this.contract_implementation_fee();
      }
    }

    return cost * this.annual_price_increase(year);
  }

  streamline_healthcare_operations_label() {
    return this.input.streamline_healthcare_operations_label;
  }

  mitigate_risk_label() {
    return this.input.mitigate_risk_label;
  }

  reduce_time_managing_docs_label() {
    return this.input.reduce_time_managing_docs_label;
  }

  reduce_time_reporting_label() {
    return this.input.reduce_time_reporting_label;
  }

  reduce_time_tracking_issues_label() {
    return this.input.reduce_time_tracking_issues_label;
  }

  avoid_penalties_label() {
    return this.input.avoid_penalties_label;
  }

  avoid_reputational_damage_label() {
    return this.input.avoid_reputational_damage_label;
  }

  reduce_cost_of_external_assessments_label() {
    return this.input.reduce_cost_of_external_assessments_label;
  }
}

export default SymplrGrc;
